import axios from "axios";

export const API_URL =
  "https://elegeek-server-ecom.vercel.app" ||
  process.env.REACT_APP_API_URL ||
  "";
export const SITE_URL =
  process.env.REACT_APP_SITE_URL ||
  (typeof window !== "undefined" ? window.location.origin : "");

const api = axios.create({ baseURL: `${API_URL}/api`, timeout: 30000 });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("eg_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (res) => res.data,
  (err) => {
    const message =
      err.response?.data?.message || err.message || "Something went wrong";
    if (err.response?.status === 401 && localStorage.getItem("eg_token")) {
      localStorage.removeItem("eg_token");
      window.dispatchEvent(new Event("eg:logout"));
    }
    return Promise.reject(
      Object.assign(new Error(message), {
        status: err.response?.status,
        data: err.response?.data,
      })
    );
  }
);

// Resolves media paths returned by the API to absolute URLs.
export const mediaUrl = (path) => {
  if (!path) return "";
  if (/^(https?:)?\/\//.test(path) || path.startsWith("data:")) return path;
  return `${API_URL}${path.startsWith("/") ? "" : "/"}${path}`;
};

export default api;
